import { getEnv } from "#app/lib/env";

const MARKETING_URL = getEnv(
  "EXPO_PUBLIC_MARKETING_URL",
  "https://salestrak.io",
).replace(/\/$/, "");

/** Public marketing-site changelog (the monthly announcements digest). */
export const CHANGELOG_URL = `${MARKETING_URL}/changelog`;

export const TERMS_URL = `${MARKETING_URL}/terms`;

export const PRIVACY_URL = `${MARKETING_URL}/privacy`;
